export const UPDATE_SINGLE_FIELD = "api/misc/update_single_field/{model}/{id}"